import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpPlayerPattern implements ICommand
{

	public Result : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Result = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.Result);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpPlayerPattern();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Result(B)='+this.Result+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50091;
	}

	public getCmdName() : string
	{
		return 'SpPlayerPattern';
	}

}
